import { Button, Modal, Result, Select } from "antd";
const { Option } = Select;

/** @type {import('./types').ISuccessResultProps} */
const SuccessResult = ({ show, title, subTitle, okText, onOkClick, onCancelClick = null, cancelText = null }) => {
    return (
        <Modal open={show} centered closable={false} maskClosable={false} destroyOnHidden={true} footer={null}>
            <Result
                status="success"
                title={title}
                subTitle={subTitle}
                extra={[
                    <Button key={`${subTitle}-OkButton`} type="primary" onClick={() => onOkClick && onOkClick()}>
                        {okText || "Ok"}
                    </Button>,
                    onCancelClick && (
                        <Button key={`${subTitle}-CancelButton`} onClick={() => onCancelClick && onCancelClick()}>
                            {cancelText || "Cancel"}
                        </Button>
                    ),
                ]}
            />
        </Modal>
    );
};

export default SuccessResult;
